// import { useState } from 'react';
// import { deleteProjectApi } from '../../apis/projectApi'; // adjust path to your API file

// export const useDeleteProject = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const deleteProject = async (projectId) => {
//     setLoading(true);
//     setError(null);
//     try {
//       await deleteProjectApi(projectId); // your axios.delete call
//       return true;
//     } catch (err) {
//       setError(err.response?.data?.detail || "Failed to delete project");
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { deleteProject, deleteLoading: loading, deleteError: error };
// };
import { useState } from "react";
import { toast } from "react-toastify";
import { deleteProjectApi } from "../../apis/projectApi";

export const useDeleteProject = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
      // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
          "Failed to delete project. Please try again.",
      };
    };

  const deleteProject = async (projectId) => {
    setLoading(true);
    setError(null);

    const toastId = toast.loading("Deleting project...");

    try {
      await deleteProjectApi(projectId);

      toast.update(toastId, {
        render: (
          <div>
            <strong>Project Deleted</strong>
            <div>The project was removed successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      return true;
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError({ title, issue });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    deleteProject,
    deleteLoading: loading,
    deleteError: error,
  };
};